import CollapsibleContainer from './CollapsibleContainer';

export default CollapsibleContainer;
